import { downloadFile } from '@root/query'
import toast from 'react-hot-toast'
import { saveBlobAsFile } from './saveBlobAsFile'

export const downloadFileToBeSaved = (
  slug: string,
  fileId: number,
  filename: string,
  errorMsg: string
) => {
  downloadFile({ slug, fileId })
    .then(blob => saveBlobAsFile(blob, filename, false))
    .catch(() => {
      toast.error(errorMsg)
    })
}
